/* eslint-disable */
import React, { useState, useEffect, useReducer, useContext, useRef,} from 'react';
import { withRouter } from 'react-router';
import 'antd/dist/antd.css';
import './index.scss';
import { Table, Input, InputNumber, Form, Typography, Collapse, message, Tooltip } from 'antd';
import { CheckOutlined, CloseOutlined, PlusCircleOutlined, CaretRightOutlined, DeleteFilled} from "@ant-design/icons";
import type { ColumnsType, TableProps, ColumnType } from 'antd/es/table';
import { formatValue, formatHistoryValue, formatTime, formatHistoryTime } from '../../utils/auth'
import { connect } from "react-redux";
import * as createActions from "../../actions/createTrial.js";
import IEDetailsModal from '../IEDetailsModal';
const { Panel } = Collapse;

interface TableColumns {
  Key: string;
  'Eligibility Criteria': string;
  Frequency: number;
  user_value_free_text: string;
  user_timeframe: string;
  user_roa: string;
  user_acuity: string;
  user_treatment: string;
  user_anatomical_site: string;
  splitPart?: boolean;
  negation?: boolean;
}

interface EditableColumnType extends ColumnType<TableColumns> {
  editable?: boolean;
}
const EditableCell = ({ editing, dataIndex, title, inputType, record, index, children, ...restProps }) => {
  const inputNode = inputType === 'number' ? <InputNumber maxLength={title == 'Eligibility Criteria'?61:501}/> : <Input maxLength={title == 'Eligibility Criteria'?61:501}/>;
  return (
    <td {...restProps}>
      {editing ? (
        (record['splitPart'] === undefined || (record['splitPart'] === true && title === 'Values'))?(
        <Form.Item name={dataIndex} style={{margin: 0}}
          rules={title == 'Eligibility Criteria'?[
            { required: (title == 'Eligibility Criteria'), message: `Please Input ${title}!` },
            { type: 'string' },
            { max: 60 },
          ]:[
            { required: (title == 'Eligibility Criteria'), message: `Please Input ${title}!` },
            { type: 'string' },
            { max: 500, message: 'My modifiers should be within 500 characters.' },
          ]}>
          {inputNode}
        </Form.Item>
        ):(
          children
        )
      ) : (
        children
      )}
    </td>
  );
};

const initialEditable = {}

const EditTable = (props) => {
  const activeTabKey = JSON.parse(localStorage.getItem('activeTabKey'));
  const collapsedId= localStorage.getItem('ts_id');
  const storageKey= activeTabKey === '1' ? `IncluEntityActivePanels_${collapsedId}` :`ExcluEntityActivePanels_${collapsedId}`;
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [editingKey, setEditingKey] = useState('');
  const [manuallyAdd, setManuallyAdd] = useState(false);
  const [total, setTotal] = useState(0)
  const [visible, setVisible] = useState(false);
  const [activeKey, setActiveKey] = useState([]);
  const [editable, setEditable] = useReducer(
        (state, newState) => ({ ...state, ...newState }),
        { ...initialEditable }
  );
  const [viewOnly, setViewOnly] = useState(false)
  const [itemRecord, setItemRecord] = useState({});
  const [currentHistoryData, setCurrentHistoryData] = useState({});
  const [detailData, setDetailData] = useState([
    {
      key: '1',
      name: 'Values',
      history: formatHistoryValue(currentHistoryData)|| '-',
      modifiers: formatValue(itemRecord)==='-'?'':formatValue(itemRecord),
    },
    {
      key: '2',
      name: 'Timeframe',
      history: formatHistoryTime(currentHistoryData)|| '-',
      modifiers: formatTime(itemRecord)==='-'?'':formatTime(itemRecord),
    },
    {
      key: '3',
      name: 'RoA',
      history: currentHistoryData['historical_roa'] || '-',
      modifiers: itemRecord['user_roa'] || '',
    },
    {
      key: '4',
      name: 'Acuity',
      history:currentHistoryData['historical_acuity'] || '-',
      modifiers: itemRecord['user_acuity'] || '',
    },
    {
      key: '5',
      name: 'Treatment modifier',
      history: currentHistoryData['historical_treatment'] || '-',
      modifiers: itemRecord['user_treatment'] || '',
    },
    {
      key: '6',
      name: 'Anatomical site',
      history: currentHistoryData['historical_anatomical_site'] || '-',
      modifiers: itemRecord['user_anatomical_site'] || '',
    },
  ]);
  useEffect(() => {
    setDetailData([
      {
        key: '1',
        name: 'Values',
        history: formatHistoryValue(currentHistoryData)|| '',
        modifiers: formatValue(itemRecord)==='-'?'':formatValue(itemRecord),
      },
      {
        key: '2',
        name: 'Timeframe',
        history: formatHistoryTime(currentHistoryData)|| '',
        modifiers: formatTime(itemRecord)==='-'?'':formatTime(itemRecord),
      },
      {
        key: '3',
        name: 'RoA',
        history: currentHistoryData['historical_roa'] || '-',
        modifiers: itemRecord['user_roa'] || '',
      },
      {
        key: '4',
        name: 'Acuity',
        history:currentHistoryData['historical_acuity'] || '-',
        modifiers: itemRecord['user_acuity'] || '',
      },
      {
        key: '5',
        name: 'Treatment modifier',
        history: currentHistoryData['historical_treatment'] || '-',
        modifiers: itemRecord['user_treatment'] || '',
      },
      {
        key: '6',
        name: 'Anatomical site',
        history: currentHistoryData['historical_anatomical_site'] || '-',
        modifiers: itemRecord['user_anatomical_site'] || '',
      },
    ])
  },[]);

  useEffect(() => {
    if(props.viewOnly != undefined){
      setViewOnly(props.viewOnly)
    }
  },[props.viewOnly]);



  useEffect(() => {
    let newList = []
    props.data.map((item, id) =>{
      if(item['splitPart'] === undefined){
      // this method is called during load of both complete trial and IE builder and edit in IE builder
        if(!('user_value_free_text' in item && item['user_value_free_text']!=null && item['user_value_free_text']!=undefined && item['user_value_free_text'] == "-")){
            item['user_value_free_text'] = formatValue(item)
        }
        newList.push(item)
      }

      if(item['Children']&&item['Children'].length > 0 ){

        item['Children']=item['Children'].filter((iten)=>{
          return iten['Eligibility Criteria']!==''&&iten['user_timeframe']!==''&&iten['user_value_free_text']!==''
        })

        item['Children'].forEach((subRecord,idx) => {
          let iten = item['Key'] + subRecord['Key']
          
         form.setFieldsValue({
          [iten + 'eligibilitycriteria']: subRecord['Eligibility Criteria'],
          [iten + 'timeframe']:subRecord['user_timeframe'],
          [iten + 'values']:subRecord['user_value_free_text']
        });
       })
      }

      if(item['Condition Or Exception'] !== undefined && item['Condition Or Exception'] !== ''){
        newList.push({
          'Key': item.Key+'C',
          'Eligibility Criteria': item['Eligibility Criteria'] + ' [Condition/Exception]',
          'user_value_free_text': item['Condition Or Exception'],
          'splitPart': true,
          'MainKey': item.Key
        })
      }
    })
    if(props.data.length > 0){
      setTotal(Number(props.data[props.data.length-1].Key))
    }

    setData(newList)
  }, [props.data])
  useEffect(() => {
    const storedValues = JSON.parse(sessionStorage.getItem(storageKey));
    if (!storedValues) {
      setActiveKey(['2','3','4','5']);
      sessionStorage.setItem(storageKey, JSON.stringify(['2','3','4','5']));
    } 
    else{
      setActiveKey(storedValues);
    }
  }, [activeTabKey]);
 
  const isEditing = (record) => record.Key == editingKey;

  const edit = (record) => {
    if(viewOnly) return;
    if (record['Eligibility Criteria'] !== ''|| record['user_value_free_text'] !== '' ||record['user_timeframe'] !== '') {
      // delete the empty criteria in editing when start to edit the other criteria
      let tempData = JSON.parse(JSON.stringify(data))
      tempData = tempData.filter((item)=>{
        return item['Eligibility Criteria'] !== ''|| item['user_value_free_text'] !== '' ||item['user_timeframe'] !== ''
      })
      setData(tempData);
    }
    form.setFieldsValue({
      "Eligibility Criteria": '',
      user_value_free_text: '',
      user_timeframe: '',
      ...record,
      Frequency: (Math.round(record.Frequency * 10000) / 100).toString(),
    });
    setEditingKey(record.Key);
    setManuallyAdd(false)
  };

  const cancel = (record) => {
    setEditingKey('');
    setManuallyAdd(false);
    // For new empty criteria, cancel editing and delete it
    if(record['Eligibility Criteria'] === '' && record['user_value_free_text'] === '' && record['user_timeframe'] === '' ) {
      handleDelete(record)
    }else{
      setTotal(total - 1)
    }
  };

  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const addedItemindex = newData.findIndex((item) => item['Eligibility Criteria'].toLowerCase() === row['Eligibility Criteria'].toLowerCase());
      if(addedItemindex > -1) {
        message.error('The criteria you are trying to add is already present in your trial!.');
        return;
      } 
      const libraryItemindex = props.libraryData.findIndex((item) => item.Text.toLowerCase() === row['Eligibility Criteria'].toLowerCase()); 
      if(libraryItemindex > -1) {
        message.error('The criteria you are trying to add is available in the historical criteria library. Please add it by using the “Add Criteria“ option.”');
        return;
      }
      const index = newData.findIndex((item) => key === item.Key);
      if (index > -1) {
        var domian;
        var realIndex;
        var newFileds;
        if(newData[index]['splitPart']){
          realIndex = index - 1
          domian = newData[index - 1]
          newFileds = {'Condition Or Exception': row.user_value_free_text}
        } else {
          realIndex = index
          domian = newData[index]
          newFileds = Object.assign(row)
        }
        newData.splice(realIndex, 1, { ...domian, ...newFileds });
        const tempData = newData.map((item, id) => {
          return item
        })
        setData(tempData);
        setEditingKey('');
        setManuallyAdd(false);
        const temp = []
        tempData.map((it, id) =>{
          if(it['splitPart'] === undefined){
            temp.push(it)
          }
        })
        props.updateCriteria(temp, props.tableIndex)
      } else {
        newData.push(row);
        setData(newData);
        setEditingKey('');
        setManuallyAdd(false);
        const temp = []
        newData.map((it, id) =>{
          if(it['splitPart'] === undefined){
            temp.push(it)
          }
        })
        props.updateCriteria(temp, props.tableIndex)
      }
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  };

  const handleAdd = async (e,category) => {
    e.stopPropagation();
    try{
      const row = await form.validateFields();
      const newData = {
        Key: (total + 1) + ' ',
        "Eligibility Criteria": '',
        user_value_free_text: '',
        user_timeframe: '',
        Frequency: 0,
        criteria_category:category,
        user_acuity: '',
        negation: false,
        user_roa: '',
        user_treatment: '',
        user_anatomical_site: '',
        user_value: '',
      }
      setTotal(total + 1)
      setData([...data, newData])
      edit(newData)
      setManuallyAdd(true)
    } catch (errInfo) {
    console.error(" Error while adding the criteria, Error:", errInfo)
    }
  };

  const handleDelete = async (record) => {
    const newData = [...data];
    const index = newData.indexOf(record);
    setTotal(total - 1)

      if (index > -1) {
        newData.splice(index, 1);
        const tempData = newData.map((item, id) => {
          return item
        })
        setData(tempData);

        const temp = []
        tempData.map((it, id) =>{
          if(it['splitPart'] === undefined){
            temp.push(it)
          }
        })
        props.updateCriteria(temp, props.tableIndex)
      }
  };

  const deleteConditionOrException = async (record) => {
    const newData = [...data];
    const index = newData.findIndex((item) => record.Key === item.Key);
    var realIndex = index - 1
    var domian = newData[realIndex]
    var row = {'Condition Or Exception': ''}

    newData.splice(realIndex, 1, { ...domian, ...row });
    newData.splice(index, 1);
    const tempData = newData.map((item, id) => {
      return item
    })
    setData(tempData);
    setEditingKey('');
    const temp = []
    tempData.map((it, id) =>{
      if(it['splitPart'] === undefined){
        temp.push(it)
      }
    })
    props.updateCriteria(temp, props.tableIndex)
  }

 
  
  function callback(key) {
    setActiveKey(key);
    let activePanels = [];
    activePanels = JSON.parse(sessionStorage.getItem(storageKey));
    if (key.includes(props.tableIndex.toString())){
      activePanels.push(props.tableIndex);
    } else {
      const index = activePanels.indexOf(props.tableIndex.toString())
      if(index > -1) {
        activePanels.splice(index, 1);
      }
    }
    sessionStorage.setItem(storageKey, JSON.stringify(activePanels));
  }
  const genExtra = (category) => (
    !viewOnly && <PlusCircleOutlined className="right-icon" style={{marginTop: '-18px'}} onClick={(e)=>handleAdd(e,category)}/>
   )

  const panelHeaderSection = (header, count) => {
    return (
        <div className={`${props.collapsible  ? '' : 'none-click'} trial-panelHeader`}>
          <div className="header-section">
            <span>{header} ({count == 0 ? 0 : count})</span>
          </div>
        </div>
    );
  };
  // const columns = [
  const columns : EditableColumnType[] = [
    {
      title: "Eligibility Criteria",
      dataIndex: "Eligibility Criteria",
      width: '12.5%',
      editable: true,
      render:(_, record) => {
        const editable = isEditing(record);
        return record.splitPart ? (
          <Typography.Link style={{cursor: 'default'}}>
            <div style={{textAlign: 'left'}}><span style={{fontSize: '14px'}}>{record['Eligibility Criteria']}</span></div>
          </Typography.Link>
        ) : (editable ? (
          <Input disabled={true} value={record["Eligibility Criteria"]} />
        ) : (
          <Typography.Link style={{ display: 'block', textAlign: 'left' }}>
          {record.negation && (
            <Tooltip title="Negated Entity" placement="topLeft" style={{ marginRight: '2px' }}>
              <span style={{ color: '#ca4a04', fontSize: '18px', marginRight: '7px'}}>≠</span>
            </Tooltip>
          )}
          <Tooltip title={record['Eligibility Criteria']} placement="topLeft">
            <div className="criteria-ellipsis-large" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
              <span style={{ fontSize: '14px' }}>{record["Eligibility Criteria"]}</span>
            </div>
          </Tooltip>
        </Typography.Link>
        ));
      }
      
    },{
      title: "Frequency",
      dataIndex: "Frequency",
      width: '12.5%',
      editable: false,
      render: (_, record) => {
        const editable = isEditing(record);
        return record.splitPart ? (
          <Typography.Link style={{cursor: 'default'}}>
          <div><span style={{fontSize: '14px'}}>{record['Frequency'] + "%"}</span></div>
          </Typography.Link>
        ) : (editable ? (
          <Input disabled={true} value={Math.round(record['Frequency'] * 10000) / 100 + "%"} />
        ) : (
          <Typography.Link>
            <Tooltip title={Math.round(record['Frequency'] * 10000) / 100 + "%"} placement="topLeft">
              <div className="criteria-ellipsis"><span style={{fontSize: '14px'}}>{Math.round(record['Frequency'] * 10000) / 100 + "%"}</span></div>
            </Tooltip>
          </Typography.Link>
        ))
      }
    },{
      title: 'Values',
      dataIndex: 'user_value_free_text',
      width: '12.5%',
      editable: true,
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <Input value={formatValue(record)}/>
        ) : (
          <Typography.Link>
            <Tooltip title={formatValue(record)===''?'-':formatValue(record)} placement="topLeft">
              <div className="criteria-ellipsis"><span style={{fontSize: '14px'}}>{formatValue(record)===''?'-':formatValue(record)}</span></div>
            </Tooltip>
          </Typography.Link>
        )
      }
    }, {
      title: 'Timeframe',
      dataIndex: 'user_timeframe',
      width: '12.5%',
      editable: true,
      render: (_, record) => {
        const editable = isEditing(record);
        return record.splitPart ? (
          <div><span style={{fontSize: '14px'}}>{formatTime(record)}</span></div>
        ) : ( editable ? (
            <Input value={formatTime(record)}/>
        ) : (
          <Typography.Link>
            <Tooltip title={formatTime(record)} placement="topLeft">
              <div className="criteria-ellipsis"><span style={{fontSize: '14px'}}>{formatTime(record)}</span></div>
            </Tooltip>
          </Typography.Link>
        ))
      }
    },
     {
      title: 'RoA',
      dataIndex: 'user_roa',
      width: '12.5%',
      editable: true,
      render: (_, record) => {
        const editable = isEditing(record);
        return record.splitPart ? (
          <div><span style={{fontSize: '14px'}}>{record.user_roa ? record.user_roa : '-'}</span></div>
        ) : ( editable ? (
            <Input value={record["user_roa"]}/>
        ) : (
          <Typography.Link>
            <Tooltip title={record.user_roa ? record.user_roa : '-'} placement="topLeft">
              <div className="criteria-ellipsis"><span style={{fontSize: '14px'}}>{record.user_roa ? record.user_roa : '-'}</span></div>
            </Tooltip>
          </Typography.Link>
        ))
      }
    },
    , {
      title: 'Acuity',
      dataIndex: 'user_acuity',
      width: '12.5%',
      editable: true,
      render: (_, record) => {
        const editable = isEditing(record);
        return record.splitPart ? (
          <div><span style={{fontSize: '14px'}}>{record.user_acuity ? record.user_acuity : '-'}</span></div>
        ) : ( editable ? (
            <Input value={record["user_acuity"]}/>
        ) : (
          <Typography.Link>
            <Tooltip title={record.user_acuity ? record.user_acuity : '-'} placement="topLeft">
              <div className="criteria-ellipsis"><span style={{fontSize: '14px'}}>{record.user_acuity ? record.user_acuity : '-'}</span></div>
            </Tooltip>
          </Typography.Link>
        ))
      }
    },
    , {
      title: 'Treatment modifier',
      dataIndex: 'user_treatment',
      width: '12.5%',
      editable: true,
      render: (_, record) => {
        const editable = isEditing(record);
        return record.splitPart ? (
          <div><span style={{fontSize: '14px'}}>{record.user_treatment ? record.user_treatment : '-'}</span></div>
        ) : ( editable ? (
            <Input value={record["user_treatment"]}/>
        ) : (
          <Typography.Link>
            <Tooltip title={record.user_treatment ? record.user_treatment : '-'} placement="topLeft">
              <div className="criteria-ellipsis"><span style={{fontSize: '14px'}}>{record.user_treatment ? record.user_treatment : '-'}</span></div>
            </Tooltip>
          </Typography.Link>
        ))
      }
    },
    {
      title: 'Anatomical site',
      dataIndex: 'user_anatomical_site',
      width: '8.333%',
      editable: true,
      render: (_, record) => {
        const editable = isEditing(record);
        return record.splitPart ? (
          <div><span style={{fontSize: '14px'}}>{record.user_anatomical_site ? record.user_anatomical_site : '-'}</span></div>
        ) : ( editable ? (
            <Input value={record["user_anatomical_site"]}/>
        ) : (
          <Typography.Link>
            <Tooltip title={record.user_anatomical_site ? record.user_anatomical_site : '-'} placement="topLeft">
              <div className="criteria-ellipsis"><span style={{fontSize: '14px'}}>{record.user_anatomical_site ? record.user_anatomical_site : '-'}</span></div>
            </Tooltip>
          </Typography.Link>
        ))
      }
    },
    {
      title: 'operation',
      dataIndex: 'operation',
      width: !viewOnly? '4.17%':'0%',
      className: !viewOnly? 'operation':'not-show',
      render: (_, record) => {
        const editable = isEditing(record);
        return !viewOnly && (editable ? (
          <span style={{float:'right'}}>
            <CheckOutlined onClick={() => save(record.Key)} style={{color: 'black'}}/> &nbsp;&nbsp;
            <CloseOutlined className='close-icon' onClick={() => cancel(record)} style={{color: 'black'}}/>
          </span>
        ) : (record.splitPart ? (
          <CloseOutlined style={{ color: 'black', float:'right'}} onClick={() =>deleteConditionOrException(record)}/>
        ) : (
          <span style={{float:'right',width: 67}}>
            <span style={{color:'#CA4A04',marginRight:8,cursor:'pointer'}} onClick={() => showMoreCriteriaDetails(record)}>Details</span>
            <DeleteFilled className= 'delete-icon' style={{color:'#BABABA',verticalAlign:'text-bottom'}} onClick={() => handleDelete(record)}/>
          </span>
        )))
      }
    }
  ];

  const showMoreCriteriaDetails = (record) => {
    const newData = [...data];
    const index = newData.findIndex((item) => record.Key === item.Key);
    setCurrentHistoryData(newData[index])
    setItemRecord(newData[index])
    setDetailData([
      {
        key: '1',
        name: 'Values',
        history: formatHistoryValue(newData[index])|| '',
        modifiers: formatValue(newData[index])==='-'?'':formatValue(newData[index]),
      },
      {
        key: '2',
        name: 'Timeframe',
        history: formatHistoryTime(newData[index])|| '',
        modifiers: formatTime(newData[index])==='-'? '':formatTime(newData[index]),
      },
      {
        key: '3',
        name: 'RoA',
        history: newData[index]['historical_roa'] || '-',
        modifiers: newData[index]['user_roa'] || '',
      },
      {
        key: '4',
        name: 'Acuity',
        history:newData[index]['historical_acuity'] || '-',
        modifiers: newData[index]['user_acuity'] || '',
      },
      {
        key: '5',
        name: 'Treatment modifier',
        history: newData[index]['historical_treatment'] || '-',
        modifiers: newData[index]['user_treatment'] || '',
      },
      {
        key: '6',
        name: 'Anatomical site',
        history: newData[index]['historical_anatomical_site'] || '-',
        modifiers: newData[index]['user_anatomical_site'] || '',
      },
    ])
    
    setVisible(true)
  }

  const mergedColumns = columns.map((col) => {
    if(col.title === "Eligibility Criteria" && manuallyAdd) {
      col.editable = true
    } else if (col.title === "Eligibility Criteria"&& !manuallyAdd){
      col.editable = false
    }
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: TableColumns) => ({
        record,
        inputType: 'text',
        dataIndex: col.dataIndex,
        title: col.title as string,
        editing: isEditing(record),
      }),
    };
  });


  const handleCancel = () =>{
    
    setVisible(false)
    props.resetInsightsModal()
    setItemRecord({})
  }

  const onCopyToMyModifier = () =>{
    setDetailData([
      {
        key: '1',
        name: 'Values',
        history: formatHistoryValue(currentHistoryData)|| '',
        modifiers: formatHistoryValue(currentHistoryData)==='-'?'':formatHistoryValue(currentHistoryData),
      },
      {
        key: '2',
        name: 'Timeframe',
        history: formatHistoryTime(currentHistoryData)|| '',
        modifiers: formatHistoryTime(currentHistoryData)==='-'?'':formatHistoryTime(currentHistoryData),
      },
      {
        key: '3',
        name: 'RoA',
        history: currentHistoryData['historical_roa'] || '-',
        modifiers: currentHistoryData['historical_roa'] || '',
      },
      {
        key: '4',
        name: 'Acuity',
        history:currentHistoryData['historical_acuity'] || '-',
        modifiers: currentHistoryData['historical_acuity'] || '',
      },
      {
        key: '5',
        name: 'Treatment modifier',
        history: currentHistoryData['historical_treatment'] || '-',
        modifiers: currentHistoryData['historical_treatment'] || '',
      },
      {
        key: '6',
        name: 'Anatomical site',
        history: currentHistoryData['historical_anatomical_site'] || '-',
        modifiers: currentHistoryData['historical_anatomical_site'] || '',
      },
    ])

    setItemRecord(currentHistoryData)

  }

  useEffect(() => {
    if(props.insightSelected) {
      setItemRecord(props.insightSelected)
      setDetailData([
        {
          key: '1',
          name: 'Values',
          history: formatHistoryValue(props.insightSelected)|| '',
          modifiers: formatValue(props.insightSelected)==='-'?'':formatValue(props.insightSelected),
        },
        {
          key: '2',
          name: 'Timeframe',
          history: formatHistoryTime(props.insightSelected)|| '',
          modifiers: formatTime(props.insightSelected)==='-'? '':formatTime(props.insightSelected),
        },
        {
          key: '3',
          name: 'RoA',
          history: props.insightSelected['historical_roa'] || '-',
          modifiers: props.insightSelected['user_roa'] || '',
        },
        {
          key: '4',
          name: 'Acuity',
          history:props.insightSelected['historical_acuity'] || '-',
          modifiers: props.insightSelected['user_acuity'] || '',
        },
        {
          key: '5',
          name: 'Treatment modifier',
          history: props.insightSelected['historical_treatment'] || '-',
          modifiers: props.insightSelected['user_treatment'] || '',
        },
        {
          key: '6',
          name: 'Anatomical site',
          history: props.insightSelected['historical_anatomical_site'] || '-',
          modifiers: props.insightSelected['user_anatomical_site'] || '',
        },
      ])
      setCurrentHistoryData(props.insightSelected)
    }
  }, [props.insightSelected])

  useEffect(() => {
    setVisible(props.addInsightsModal)
  }, [props.addInsightsModal])

  const handleOkActivity = (e, itemRecord) => {
    const newItem = {
      ...itemRecord,
      user_lower: 0,
      user_units: "",
      user_upper: 0,
      "user_value": "",
    }

    detailData.forEach(item => {
      if (item.name === "Timeframe") newItem.user_timeframe = item["modifiers"].trim()
      if (item.name === "Values") newItem.user_value_free_text = item["modifiers"].trim()
      if (item.name === "Acuity") newItem.user_acuity = item["modifiers"].trim()
      if (item.name === "RoA") newItem.user_roa = item["modifiers"].trim()
      if (item.name === "Treatment modifier") newItem.user_treatment = item["modifiers"].trim()
      if (item.name === "Anatomical site") newItem.user_anatomical_site = item["modifiers"].trim()
    });

    setItemRecord(newItem)
    
    setVisible(false)
    // save edit to table
    if(props.addInsightsModal) {
     insightsDetailSave(newItem);
    } else {
      detailSave(newItem)
    }
    props.resetInsightsModal(props.insightRecordSelected)
  }

  const insightsDetailSave = async(newItem) => {
    const activeTabKey = JSON.parse(localStorage.getItem('activeTabKey'))
    let newData, tableIndex;
    switch(props.newIE.insight_type) {
      case 'medical':
        tableIndex = 3;
        if(activeTabKey == "1") {
          newData = [...props.newIE.medConditionElements, props.insightSelected];
          props.updateIEActivities({
            medConditionElements: newData,
          })
        } else if(activeTabKey == "2") {
          newData = [...props.newIE.excluMedConditionElements, props.insightSelected];
          props.updateIEActivities({
            excluMedConditionElements: newData,
          })
        }
        break;
      case 'demographics':
        tableIndex = 2;
        if(activeTabKey == "1") {
          newData = [...props.newIE.demographicsElements, props.insightSelected];
          props.updateIEActivities({
            demographicsElements: newData,
          })
        } else if(activeTabKey == "2") {
          newData = [...props.newIE.excluDemographicsElements, props.insightSelected];
          props.updateIEActivities({
            excluDemographicsElements:newData,
          })

        }
        break;
      case 'intervention':
        tableIndex = 4;
        if(activeTabKey == "1") {
          newData = [...props.newIE.interventionElements, props.insightSelected];
          props.updateIEActivities({
            interventionElements: newData,
          })
        } else if(activeTabKey == "2") {
          newData = [...props.newIE.excluInterventionElements, props.insightSelected];
          props.updateIEActivities({
            excluInterventionElements: newData,
          })
        }
        break;
      case 'labs':
        tableIndex = 5;
        if(activeTabKey == "1") {
          newData = [...props.newIE.labTestElements, props.insightSelected];
          props.updateIEActivities({
            labTestElements: newData,
          })
        } else if(activeTabKey == "2") {
          newData = [...props.newIE.excluLabTestElements, props.insightSelected];
          props.updateIEActivities({
            excluLabTestElements: newData,
          })
        }
        break;
      default:
        break;
    }
    try{
      const key = newItem['Eligibility Criteria']
      const index = newData.findIndex((item) => key === item['Eligibility Criteria']);
      if (index > -1) {
        var domian;
        var realIndex;
        var newFileds;
        if(newData[index]['splitPart']){
          realIndex = index - 1
          domian = newData[index - 1]
          newFileds = {'Condition Or Exception': newItem.user_value_free_text}
        } else {
          realIndex = index
          domian = newData[index]
          newFileds = Object.assign(newItem)
        }
        newData.splice(realIndex, 1, { ...domian, ...newFileds });
        const tempData = newData.map((item, id) => {
          return item
        })
        setData(tempData);
        setEditingKey('');
        setManuallyAdd(false);
        const temp = []
        tempData.map((it, id) =>{
          if(it['splitPart'] === undefined){
            temp.push(it)
          }
        })
        props.updateCriteria(temp, tableIndex)
      } else {
        newData.push(newItem);
        setData(newData);
        setEditingKey('');
        setManuallyAdd(false);
        const temp = []
        newData.map((it, id) =>{
          if(it['splitPart'] === undefined){
            temp.push(it)
          }
        })
        props.updateCriteria(temp, tableIndex)
      }
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  }

  const detailSave = async (newItem) => {
    try {
      const key = newItem.Key
      const newData = [...data];
      const index = newData.findIndex((item) => key === item.Key);
      if (index > -1) {
        var domian;
        var realIndex;
        var newFileds;
        if(newData[index]['splitPart']){
          realIndex = index - 1
          domian = newData[index - 1]
          newFileds = {'Condition Or Exception': newItem.user_value_free_text}
        } else {
          realIndex = index
          domian = newData[index]
          newFileds = Object.assign(newItem)
        }
        newData.splice(realIndex, 1, { ...domian, ...newFileds });
        const tempData = newData.map((item, id) => {
          return item
        })
        setData(tempData);
        setEditingKey('');
        setManuallyAdd(false);
        const temp = []
        tempData.map((it, id) =>{
          if(it['splitPart'] === undefined){
            temp.push(it)
          }
        })
        props.updateCriteria(temp, props.tableIndex)
      } else {
        newData.push(newItem);
        setData(newData);
        setEditingKey('');
        setManuallyAdd(false);
        const temp = []
        newData.map((it, id) =>{
          if(it['splitPart'] === undefined){
            temp.push(it)
          }
        })
        props.updateCriteria(temp, props.tableIndex)
      }
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  };

  interface DataType {
    key: React.Key;
    title: string;
    amendment: string;
    before_text: string;
    after_text: string;
  }

  const criteriaDetailData = itemRecord["Detail"]&&itemRecord["Detail"]['amendment_details']&&itemRecord["Detail"]['amendment_details'].map((item, index) => {
    const tempItem = JSON.parse(JSON.stringify(item))
    return Object.assign(tempItem, {key:(index + 1) + ''})
  })



  const handleSave = (row) => {
    const newData = [...detailData];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    
    setDetailData(newData);
  };


  return (
    <Form form={form} component={false}>
      <Collapse 
      key={activeTabKey}
      className="edit-table-wrapper"
      activeKey={activeKey} 
      onChange={callback} 
      expandIconPosition="left"
      expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
      >
      <Panel 
      header={panelHeaderSection(props.panelHeader, props.collapsible ? 0 : data.length)}
      showArrow={!viewOnly}
      key={props.tableIndex} 
      forceRender={false} 
      extra={genExtra(props.panelHeader)}>
      <Table pagination={false} 
        className='new-entity-table'
        showHeader={false} 
        rowKey={record => record.Key}
        components={{ body: { cell: EditableCell } }} 
        locale={{emptyText: 'No Data'}}
        dataSource={data} columns={mergedColumns} rowClassName="editable-row"
        expandedRowKeys={data.map(item => item.Key)}
      />
      </Panel>
      </Collapse>

     <IEDetailsModal
        handleCancel={handleCancel}
        visible={visible}
        itemRecord={itemRecord}
        onCopyToMyModifier={onCopyToMyModifier}
        detailData={ detailData}
        handleOkActivity={handleOkActivity}
        handleSave={handleSave}
        isInsisghts={props.addInsightsModal}
        isAddActivity={false}
     />
    </Form>
  );
};
const mapDispatchToProps = (dispatch) => ({
  createTrial: (val) => dispatch(createActions.createTrial(val)),
  createSoa: (val) => dispatch(createActions.createSoa(val)),
  updateIEActivities: (val) => dispatch(createActions.updateIEActivities(val)),
});
const mapStateToProps = (state) => ({
  newTrial: state.trialReducer,
  newIE: state.ieReducer
});
const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(EditTable))